export const screenGetters = {
    titleList: state => state.screen.screenSet[0]??[],  
    rankingList: state => state.screen.screenSet[1]??[],  
    companyTypeList:state => {
        // console.log('aaa',state.screen.screenSet[2]??[])
        return state.screen.screenSet[2]??[];
    },
    screenWorkSheetList:state => state.screen.screenSet[3]??[],  
    
    workSheetTypeList:state =>state.screen.screenSet[4]??[],
    comeFromList:state =>state.screen.screenSet[5]??[],
    emergencyList:state =>state.screen.screenSet[6]??[],
    inOutList:state =>state.screen.screenSet[7]??[],
    mailTypeList:state =>state.screen.screenSet[8]??[],
};
